import _ from 'lodash';
import globalStore from '$$globalStore';
import ganttViewModel from '$$ganttViewModel';

export default function () {
  const viewData = ganttViewModel.getActiveViewData();

  if (!viewData) {
    return [];
  }

  if (viewData.gantt_id) {
    const columnIds = globalStore.getters['columns/getColumnIdsByProjectId'](viewData.gantt_id);

    return columnIds.reduce((result, columnId) => {
      const column = globalStore.getters['columns/getCustomColumnById'](columnId);

      if (column) {
        result.push(column);
      }

      return result;
    }, []);
  }

  if (viewData.ganttIDs) {
    return _.reduce(viewData.ganttIDs, (columns, ganttID) => {
      const columnIds = globalStore.getters['columns/getColumnIdsByProjectId'](ganttID);

      columnIds.forEach(columnId => {
        const column = globalStore.getters['columns/getCustomColumnById'](columnId);

        if (column) {
          const addedColumn = columns.find(item => item.id === column.id);

          if (!addedColumn) {
            column.ganttIds = [ganttID];
            columns.push(column);
          } else {
            addedColumn.ganttIds.push(ganttID);
          }
        }
      });

      return columns;
    }, []);
  }
}
